import Button from "@/common/elements/Button";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { useFilterSearchContext } from "@/contexts/FolderSearchContext";

const FolderDetailSearchActions = ({
  onCancel,
  onSearch,
  onSelectCurrentJacket,
  onCreateNewJacket,
  isDisabledCurrentJacket,
}) => {
  const { requestFilter } = useFilterSearchContext();
  return (
    <StyledGridRow gutter={16} justify="start">
      <StyledGridCol marginTop="10px">
        <Button type="default" color="default" onClick={onCancel}>
          Cancel
        </Button>
      </StyledGridCol>
      <StyledGridCol marginTop="10px">
        <Button type="default" color="default" onClick={onSearch}>
          Search
        </Button>
      </StyledGridCol>
      <StyledGridCol marginTop="10px">
        <Button
          type="default"
          color="default"
          onClick={onSelectCurrentJacket}
          disabled={isDisabledCurrentJacket}
        >
          Select Current Folder
        </Button>
      </StyledGridCol>
      <StyledGridCol marginTop="10px">
        <Button
          type="default"
          color="default"
          onClick={onCreateNewJacket}
          disabled={requestFilter?.length === 0}
        >
          Create New Folder
        </Button>
      </StyledGridCol>
    </StyledGridRow>
  );
};

export default FolderDetailSearchActions;
